/* STEP 11c · lane C2b (owner card 31-Oct-2026 23:15 KSA, items 2.4 and 2.5) — EN + AR of
   2.4 the associate figures asked on the cash flow of a trial-balance year (IFRSCashFlowTbInputs, owner decision D1);
   2.5 the refusal of treatment (a) when the client's voucher holds the correction among other lines (restatement preview).
   No standard paragraph is quoted. */
const I18N_S11C2B = {
  en: {
    s11c2b: {
      assoc: {
        hint: "The trial balance shows a movement on the investment in associates. It cannot tell a dividend from a purchase or a disposal: enter the figures from the client's records (0 if none).",
        assoc_dividends_received: "Dividends received from associates",
        assoc_purchases: "Purchase of investment in associates",
        assoc_disposal_proceeds: "Proceeds from disposal of associates",
      },
    },
    pya: {
      cy: {
        problem: {
          RESTATEMENT_CY_CLIENT_IN_VOUCHER: "The client's voucher already holds this correction among its other lines — use treatment (d) \"already recorded by the client\" and mark the correction lines.",
        },
      },
    },
  },
  ar: {
    s11c2b: {
      assoc: {
        hint: "يُظهر ميزان المراجعة حركة على الاستثمار في الشركات الزميلة، ولا يمكنه التمييز بين توزيعات الأرباح والشراء أو الاستبعاد: أدخل الأرقام من سجلات العميل (0 إن لم توجد).",
        assoc_dividends_received: "توزيعات الأرباح المقبوضة من الشركات الزميلة",
        assoc_purchases: "شراء استثمار في شركات زميلة",
        assoc_disposal_proceeds: "متحصلات استبعاد شركات زميلة",
      },
    },
    pya: {
      cy: {
        problem: {
          RESTATEMENT_CY_CLIENT_IN_VOUCHER: "قيد العميل يتضمن هذا التصحيح ضمن أسطره الأخرى — استخدم المعالجة (د) «سجّله العميل مسبقًا» وحدد أسطر التصحيح.",
        },
      },
    },
  },
};

export default I18N_S11C2B;
